export default "__VITE_ASSET__Bx3HsQQ2__"